import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "under-cart__promo" };
const _hoisted_2 = { class: "cart-promo" };
const _hoisted_3 = { class: "cart-promo__top" };
const _hoisted_4 = { class: "cart-promo__cover" };
const _hoisted_5 = { class: "cart-promo__marker" };
const _hoisted_6 = { class: "cart-promo__main always-visible" };
import CouponList from "./CouponList.vue";
import CouponInput from "./CouponInput.vue";
import Sprite from "../../../../components/Sprite.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Coupons',
    props: {
        coupons: { type: Array, required: true },
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("details", _hoisted_2, [
                    _createElementVNode("summary", _hoisted_3, [
                        _createElementVNode("span", _hoisted_4, [
                            _createVNode(Sprite, {
                                name: "discount",
                                size: 32
                            })
                        ]),
                        _cache[0] || (_cache[0] = _createTextVNode()),
                        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "cart-promo__title" }, "Промокоды", -1 /* CACHED */)),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        _createElementVNode("span", _hoisted_5, [
                            _createVNode(Sprite, { name: "arrow-down" })
                        ])
                    ]),
                    _cache[4] || (_cache[4] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(CouponInput),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        _createVNode(CouponList, { coupons: __props.coupons }, null, 8 /* PROPS */, ["coupons"])
                    ])
                ])
            ]));
        };
    }
});
